import { Check } from "lucide-react";
import { useState } from "react";
import { NativeLikeSelect } from "../../components/CocoaSelect";

export function FLabel({ children }) {
  return <label className="mb-1.5 block text-sm text-[#5D4037]">{children}</label>;
}

export function FInput(props) {
  return <input placeholder="Enter here" {...props} className={`h-11 w-full rounded-lg border border-[#E5DFD3] bg-white px-3.5 text-sm text-[#3E2723] placeholder:text-[#84675B] focus:outline-none focus:ring-2 focus:ring-[#8D6E63] focus:border-transparent ${props.className || ""}`} />;
}

export function FSelect({ children, placeholder = "Select here", placeholderDisabled = false, className = "", ...props }) {
  return (
    <NativeLikeSelect {...props} placeholder={placeholder} placeholderDisabled={placeholderDisabled}
      triggerClass={`h-11 w-full rounded-lg border-[#E5DFD3] bg-white px-3 text-sm focus:ring-2 focus:ring-[#8D6E63] ${props.value ? "text-[#3E2723]" : "text-[#84675B]"} ${className}`}>
      {children}
    </NativeLikeSelect>
  );
}

export function FTextarea(props) {
  return <textarea placeholder="Enter here" rows={5} {...props} className={`w-full rounded-lg border border-[#E5DFD3] bg-white px-3.5 py-3 text-sm text-[#3E2723] placeholder:text-[#84675B] focus:outline-none focus:ring-2 focus:ring-[#8D6E63] focus:border-transparent ${props.className || ""}`} />;
}

export function CheckBox({ checked, onChange, label, testId, className = "" }) {
  return (
    <button type="button" data-testid={testId} onClick={onChange}
      className={`flex items-center gap-2.5 rounded-full border px-4 py-2 text-[15px] text-left transition-colors ${checked ? "border-[#4E342E] bg-[#F5F2EB] text-[#3E2723] font-semibold" : "border-[#E5DFD3] bg-white text-[#6D4C41] hover:bg-[#FDFCF8]"} ${className}`}>
      <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-colors ${checked ? "bg-[#4E342E] border-[#4E342E]" : "bg-white border-[#C9BEB0]"}`}>
        {checked && <Check size={13} className="text-white" />}
      </span>
      <span className="flex-1">{label}</span>
    </button>
  );
}

export function YesNo({ value, onChange, testId }) {
  const opts = [["yes", "Yes"], ["no", "No"]];
  return (
    <div className="inline-flex rounded-full border border-[#D7CCC8] bg-white p-1">
      {opts.map(([v, l]) => (
        <button key={v} type="button" data-testid={`${testId}-${v}`} onClick={() => onChange(v)}
          className={`flex items-center gap-1.5 rounded-full px-6 py-2 text-[15px] font-semibold transition-colors ${value === v ? "bg-[#4E342E] text-white shadow-[0_2px_8px_rgba(78,52,46,0.25)]" : "text-[#7B6157] hover:bg-[#F5F2EB]"}`}>
          {value === v && <Check size={15} />} {l}
        </button>
      ))}
    </div>
  );
}

export function SelectWithCustom({ value, onChange, options, placeholder = "Select here", customPlaceholder = "Enter manually", testId }) {
  const known = options.includes(value);
  const [custom, setCustom] = useState(Boolean(value) && !known);
  return (
    <div>
      <FSelect data-testid={testId} value={custom ? "__custom" : value} placeholder={placeholder}
        onChange={(e) => {
          if (e.target.value === "__custom") { setCustom(true); onChange(""); }
          else { setCustom(false); onChange(e.target.value); }
        }}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
        <option value="__custom">Other - add custom…</option>
      </FSelect>
      {custom && (
        <FInput data-testid={testId ? `${testId}-custom` : undefined} className="mt-2" placeholder={customPlaceholder}
          value={value} onChange={(e) => onChange(e.target.value)} autoFocus />
      )}
    </div>
  );
}

export function WizardButtons({ onBack, onNext, nextLabel = "Next", busy }) {
  return (
    <div className="mt-8 flex justify-center gap-4">
      <button type="button" data-testid="wizard-back-btn" onClick={onBack}
        className="w-56 rounded-lg border border-[#4E342E] py-3 text-sm font-semibold text-[#4E342E] hover:bg-[#F5F2EB] transition-colors">
        Back
      </button>
      <button type="button" data-testid="wizard-next-btn" onClick={onNext} disabled={busy}
        className="w-56 rounded-lg bg-[#5D4037] py-3 text-sm font-semibold text-white hover:bg-[#4E342E] transition-colors disabled:opacity-50">
        {busy ? "Saving…" : nextLabel}
      </button>
    </div>
  );
}
